import { BIV1 } from "../borrowerInformationVersions";
import { LEV1 } from "../loanEconomicsVersions";
import { LIV1 } from "../loanInformationVersions";
import { BRIDGE_V1_ID } from "./versions";


const bridgeV1 = {
  id: BRIDGE_V1_ID,
  bplsizer: {
    inputFields: {
      borrowerInformation: BIV1,
      loanInformation: LIV1,
      loanEconomics: LEV1,
      propertyLocation: ["address", "postalCode", "city", "state"],
      propertyInformation: [
        "propertyType",
        "ExpansionOrChangeOfUseCase",
        "ValuationSource",
        "PercentOccupied",
      ],
      propertyEconomics: [
        "orgAppraisalValue",
        "purchasePrice",
        "ClosingCost",
        "AsRepairedValueARV",
        "EstimatedRentPerYearUponCompletion",
        "costBasis",
        "AssignmentFee",
        "annualPropertyTaxes",
        "annualInsurance",
        "annualHOAFee",
      ],
      loanFeatures: ["OriginalAsIsLtv", "originalAsRepairedLTV", "OriginalLtc"],
      loanCharacterization: [
        "CustomerTypeExperiencedNew",
        "PurchaseOrRefinance",
        "rehabType",
        "StabilizedFlag",
        "loanCharacterization",
      ],
      propertyLoanFeatures: [
        "cbsa",
        "MedianValue",
        "LtmHpa",
        "DaysOnMarket",
        "ESRIPopulationDensity",
      ],
    },
    outputFields: {},
  },
  mmtc: {
    inputFields: {
      borrowerInformation: {
        quickLoanSizing: [],
        detailedLoanSizing: [],
      },
      loanInformation: {
        quickLoanSizing: [],
        detailedLoanSizing: [],
      },
      loanEconomics: {
        quickLoanSizing: [],
        detailedLoanSizing: [],
      },
      propertyLocation: {
        quickLoanSizing: [],
        detailedLoanSizing: [],
      },
      propertyInformation: {
        quickLoanSizing: [],
        detailedLoanSizing: [],
      },
      propertyEconomics: {
        quickLoanSizing: [],
        detailedLoanSizing: [],
      },
      loanFeatures: {
        quickLoanSizing: [],
        detailedLoanSizing: [],
      },
      loanCharacterization: {
        quickLoanSizing: [],
        detailedLoanSizing: [],
      },
      propertyLoanCharacterization: {
        quickLoanSizing: [],
        detailedLoanSizing: [],
      },
    },
    outputFields: {},
  },
};

export default bridgeV1;
